import React, { useState } from 'react';
import style from "./index.module.scss"
import cn from "classnames";
import ActiveRadioButtonIcon from '../../shared/icons/ActiveRadioButtonIcon';
import InactiveRadioButtonIcon from '../../shared/icons/InactiveRadioButtonIcon';

const CustomLists = ({
  items,
  title = "",
  isRadioBtn = false,
  onChangeValue = () => void (0),
  prefixStart = "",
  onSelectionChange = () => { },
  activeChoice = null
}) => {

  const [activeIndex, setActiveIndex] = useState(activeChoice);

  const handleItemClick = (index) => {
    setActiveIndex(index);
    onSelectionChange(index);
  };


  return (
    <div className={style.wrapper}>
      {prefixStart && <span className={style.prefixStart}>{prefixStart}</span>}

      <ul className={style.list}>
        <div className={style.title}>
          {title}
        </div>
        <div className={style.options}>
          {items.map((item, index) => (
            <li
              key={index}
              className={cn(
                style.option,
                { [style.active]: index === activeIndex }
              )}
              onClick={() => handleItemClick(index)}
            >
              {isRadioBtn &&
                <div className={style.prefixStart}>
                  {index === activeIndex ? <ActiveRadioButtonIcon /> : <InactiveRadioButtonIcon />}
                </div>
              }
              <div className={style.content}>
                <div className={style.text}>
                  {item.text}
                </div>
                <div className={style.summary}>
                  {item.summary}
                </div>
              </div>
            </li>
          ))}
        </div>
      </ul>
    </div>
  );
};

export default CustomLists;